 $.ajax({
    type: "POST",
    url: "/cart/clear.js",
    dataType: "json",
    async:false,
    success: function (cart) {
      $(".headerCartItems").html(Number(cart.item_count));
    }
  });

const urlParamss = new URLSearchParams(window.location.search);
let boxselectqty = urlParamss.get("quantity");

const fetchStaticBoxInformation = async (boxParentProductId) => {
  return new Promise((resolve, reject) => {
    fetch("https://api.skio.com/storefront-http/get-dynamic-box", {
      method: "POST",
      body: JSON.stringify({
        productPlatformId: 7106094596131,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (!response.ok)
          throw new Error(
            "Failed to get box"
          ); 
         
         var variantbotlesize = parseInt(boxselectqty);
         var sskboxId = response.DynamicBox.boxId;
         var variantchildproducts = response.DynamicBox.selectableProductVariants;
        var sellingplanid30days = response.DynamicBox.sellingPlanGroup;
        const orderedsellingplan = Object.keys(response.DynamicBox.sellingPlanGroup).sort().reduce(
              (obj, key) => { 
                obj[key] = response.DynamicBox.sellingPlanGroup[key]; 
                return obj;
              }, 
              {}
            );

       Object.entries(orderedsellingplan).forEach(
              ([plankey, planvalue], index) => {
                if(index == 0){
                sellingid30days = plankey.replace("gid://shopify/SellingPlan/","");  
                }
                if(index == 1){
                sellingid60days = plankey.replace("gid://shopify/SellingPlan/","");  
                }
              }
            );
          
        
        var productdetail = "";
        variantchildproducts.forEach((pindex,i) => {
             var prohead = pindex.productTitle.split(' ').slice(0,2).join(' ');
             var prosub = '';
            if(prohead == 'Coco Cloud'){
              var prosub = 'Tropical vibes, vanilla, coconut';
            }else if(prohead == 'Glass Skin'){
              var prosub = 'Fresh, clean scent, white musk, coconut milk';
            }else if(prohead == 'Cooka Ingrown'){
              var prosub = 'Refreshing & bright, lavender, tea tree, primrose';
            }else if(prohead == 'Soft Serve'){
              var prosub = 'Soothing, strawberry-scented, dessert';
            }else if(prohead == 'Unicorn Fruit'){
              var prosub = 'Cotton candy, sparkling sugar, soft caramel';
            }else if(prohead == 'Smooth Legend'){
              var prosub = 'Jasmine, blackcurrant, vanilla woods';
            }else if(prohead == 'Glazed Donut'){
              var prosub = 'Fresh baked sweetness, vanilla, passionfruit';
            }
            var addtext = 'ADD';
            if(window.Shopify.routes.root.includes('/es')){
              var addtext = 'Añadir';
              if(prohead == 'Coco Cloud'){
              var prosub = 'Vibras tropicales, vainilla, coco';
              }else if(prohead == 'Glass Skin'){
                var prosub = 'Aroma fresco y limpio, almizcle blanco, leche de coco';
              }else if(prohead == 'Cooka Ingrown'){
                var prosub = 'Refrescante y brillante, lavanda, árbol de té, onagra';
              }else if(prohead == 'Soft Serve'){
                var prosub = 'Relajante, con aroma a fresa, postre';
              }else if(prohead == 'Unicorn Fruit'){
                var prosub = 'Algodón de azúcar, azúcar brillante, caramelo suave';
              }else if(prohead == 'Smooth Legend'){
                var prosub = 'Jazmín, grosella negra, vainilla con un toque de madera';
              }else if(prohead == 'Glazed Donut'){
                var prosub = 'Dulzura recién horneada, vainilla, fruta de la pasión';
              }
            }
            productdetail += `<div class="bundleboxdls_singlepro" data-index="${i}">
                                    <div class="bundleboxdls_singleimg">
                                        <img
                                            src="${pindex.productImageSrc}" alt="${pindex.productTitle}">
                                    </div>
                                    <div class="bundleboxdls_left">
                                        <div class="bundleboxdls_text">
                                            <h3>${prohead}</h3>
                                            <p>${prosub}</p>

                                        </div>
                                        <div class="bundleboxdls_increment">
                                            <div class="bundleboxdls_increcontent">
                                                <button class="decrement quality_ic">-</button>
                                                <span class="cart_counts_f" id="cart-count" data-productTitle="${pindex.productTitle}" data-variantid="${pindex.productVariants[0].platformId.replace(
                          "gid://shopify/ProductVariant/","")}" data-boxid="${sskboxId}" data-productid="${pindex.productPlatformId.replace("gid://shopify/Product/","")}" data-productprice="${pindex.productVariants[0].price}" data-sellingplanid30="${sellingid30days}" data-sellingplanid60="${sellingid60days}">0</span>
                                                <button class="increment quality_ic">+</button>
                                            </div>

                                            <div class="bundleboxdl_adds">
                                                <button class="bundle_btn">${addtext} +</button>

                                            </div>
                                        </div>
                                    </div>
                                </div>`;
         
          
        });
        $(".bundleboxdls_addproducts").html(productdetail);
         $('.bundlebox_section').removeClass('loading_skelton'); 
        /* js code start*/
        let bundleboxdls_singlepro = document.querySelectorAll(".bundleboxdls_singlepro")
              let bundlebox_card = document.querySelectorAll(".bundlebox_card")
              let selctedoffer = '';
              let quantity = variantbotlesize;
              if (quantity !== 2 && quantity !== 3 && quantity !== 4 && quantity !== 6) {
                  quantity = 6
              }
        
              let max = variantbotlesize;
              let min = variantbotlesize;
            
              $("#bottleVal").text(quantity)
              
              if (quantity === 6) {
                  selctedoffer = "40%";
                  freegiftshow = 4;
              } else if (quantity === 4) {
                  selctedoffer = "36%";
                freegiftshow = 3;
              } else if (quantity === 3) {
                  selctedoffer = "28%";
                freegiftshow = 2;
              } else {
                  selctedoffer = "13%";
                freegiftshow = 1;
              }
              
              $('#limited_offer').text(selctedoffer);
              
              let arr = [],
                  sum = 0
              
              function updateText() {
                  //console.log("quantity", quantity, "sum", sum, "min", min)
                  let text = "Proceed to checkout";
                  if(window.Shopify.routes.root.includes('/es')){
                    text = "Pasar por la caja";
                  }
                  let disabled = false;
                  let isActive = false;
              
                  if (sum === 0) {
                      text = `Select at least ${quantity} bottles`;
                      if(window.Shopify.routes.root.includes('/es')){
                        text = `Seleccione un mínimo de ${quantity} botellas`;
                      }
                      disabled = true;
                      isActive = true;
                  } else if (sum < quantity) {
                      text = `Select ${quantity - sum} more bottle${quantity - sum > 1 ? 's' : ''}`;
                      if(window.Shopify.routes.root.includes('/es')){
                        text = `Seleccione ${quantity - sum} más botella${quantity - sum > 1 ? 's' : ''}`;
                      }
                      disabled = true;
                      isActive = true;
                  } 
              
                  $("#serum_checkout_btn").prop("disabled", disabled);
                  $("#checkout_btn_text").text(text);
              
                  if (!isActive) {
                      $("#serum_checkout_btn").addClass("active_green");
                  } else {
                      $("#serum_checkout_btn").removeClass("active_green");
                  }
              }
                  
              updateText()
              $(".bundleboxdls_increcontent").hide();
    for (let i = 0; i < bundleboxdls_singlepro.length; i++) {
                    arr.push(0)
                }
              for (let i = 0; i < freegiftshow; i++) {  
                      bundlebox_card[i].classList.add("is-active")
              }
              bundleboxdls_singlepro.forEach(function (e, i) {
                  let container = $(e)
                  const bundle_btn = e.querySelector(".bundle_btn")
                  let count = container.find(".cart_counts_f").text()
                  bundle_btn.addEventListener("click", function () {
                      let newCount = e.querySelector(".cart_counts_f").innerText = 1
                      container.find(".bundleboxdls_increcontent").show()
                      arr[e.dataset.index] = parseInt(newCount)
                      sum = arr.reduce((acc, num) => acc + num, 0);
                      if (sum >= max) {
                          $(".bundleboxdls_singlepro").addClass("active-blurr");
                          $(".increment.quality_ic").addClass("active-blurr")
                          $(".bundleboxdls_singlepro").each(function () {
                              if ($(this).find(".bundleboxdls_increcontent").is(":visible")) {
                                  $(this).removeClass("active-blurr");
                              }
                          });
              
                      } else {
                          $(".bundleboxdls_singlepro").removeClass("active-blurr");
                          $(".increment.quality_ic").removeClass("active-blurr")
              
                      }
                     updateText()
                      $(this).hide()
                  })
                  e.querySelector(".increment").addEventListener("click", function () {
                      if (sum < max) {
                          let newCount = e.querySelector(".cart_counts_f").innerText++
                          newCount++
                          arr[e.dataset.index] = parseInt(newCount)
                          sum = arr.reduce((acc, num) => acc + num, 0);
                      }
                      
                      if (sum >= max) {
                          $(".bundleboxdls_singlepro").addClass("active-blurr");
                          $(".increment.quality_ic").addClass("active-blurr")
                          $(".bundleboxdls_singlepro").each(function () {
                              if ($(this).find(".bundleboxdls_increcontent").is(":visible")) {
                                  $(this).removeClass("active-blurr");
                              }
                          });
                      } else {
                          $(".bundleboxdls_singlepro").removeClass("active-blurr");
                          $(".increment.quality_ic").removeClass("active-blurr")
                      }
                     updateText()
                  })
                  e.querySelector(".decrement").addEventListener("click", function () {
                      let newCount = e.querySelector(".cart_counts_f").innerText--
                      newCount--
                      arr[e.dataset.index] = parseInt(newCount)
                      sum = arr.reduce((acc, num) => acc + num, 0);
                      if (parseInt(newCount) == 0) {
                          $(bundle_btn).show()
                          container.find(".bundleboxdls_increcontent").hide()
                      }
                    
                      if (sum >= max) {
                          $(".bundleboxdls_singlepro").addClass("active-blurr");
                          $(".increment.quality_ic").addClass("active-blurr")
                          $(this).closest(".bundleboxdls_singlepro").removeClass("active-blurr");
                      } else {
                          $(".bundleboxdls_singlepro").removeClass("active-blurr");
                          $(".increment.quality_ic").removeClass("active-blurr")
                      }
                    updateText()
                  })
              });
        /* js code end*/
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

$(document).on("click", "#serum_checkout_btn", function () {
   var properties = {};
  selectedscentsArray = [];
  let selectedproductqty = document.querySelectorAll(".cart_counts_f");
  
  let bundlelength = 0;
  var selectedProducts = [];
  selectedproductqty.forEach(function (e, i) {
    if(parseInt(e.textContent)>0){
      var variationid = e.dataset.variantid;
      var dboxid = e.dataset.boxid;
      if(boxselectqty== 2){
        var sellingplan = e.dataset.sellingplanid30;
      }else if(boxselectqty == 3 || boxselectqty == 4 || boxselectqty == 6){
        var sellingplan = e.dataset.sellingplanid60;
      }

      properties["_dynamicBoxIndex"] = 0;
      properties["_dynamicBoxId"] = dboxid;
      selectedProducts.push({id: parseInt(variationid),quantity: parseInt(e.textContent),properties: properties,selling_plan: parseInt(sellingplan)});
      bundlelength += parseInt(e.textContent);
       var selectscent = {
      item_id: parseInt(e.dataset.productid),
      item_name: e.dataset.producttitle,
      currency: "USD",
      item_brand: "Truly Beauty",
      price: parseInt(e.dataset.productprice),
      quantity: parseInt(e.textContent),
      item_variant: parseInt(variationid),
    };
    selectedscentsArray.push(selectscent);
    }
    
  });
  //console.log("selectedscentsArray",selectedscentsArray);
  dataLayer.push({ scents: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            event: "selected_scents",
            scents:  {
              items: selectedscentsArray,
            }
          });
  
  if(bundlelength == 6){
    selectedProducts.push({id: 40920114954275,properties: { "_free_with": 'Serum Starter Kit'}},{id: 40669202579491,properties: { "_free_with": 'Serum Starter Kit'}},{id: 40787199524899,properties: { "_free_with": 'Serum Starter Kit'}});
  }
  if(bundlelength == 4){
    selectedProducts.push({id: 40920114954275,properties: { "_free_with": 'Serum Starter Kit' }},{id: 40669202579491,properties: { "_free_with": 'Serum Starter Kit' }});
  }
  if(bundlelength == 3){
    selectedProducts.push({id: 40920114954275,properties: { "_free_with": 'Serum Starter Kit' } });
  }
   //console.log("serumkitproperties",selectedProducts);
    let addformData = {
     'items': selectedProducts
    };
  
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(addformData)
    })
    .then(response => {
       return response.json();
    })
    .then((json) => {
       return window.location.href = '/checkout'; // Redirect to the cart page
    })  
    .catch((error) => {
      console.error('Error:', error);
    });
});

fetchStaticBoxInformation();

 function getFullDate() {
		var monthNames = new Array("Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec.");
		var dayNames = new Array("Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday");
		var now = new Date();
		now.setDate(now.getDate());
       var english_ordinal_suffix = (now.getDate() % 10 == 1 && now.getDate() != 11 ? 'st' : 
          (now.getDate() % 10 == 2 && now.getDate() != 12 ? 'nd' : 
          (now.getDate() % 10 == 3 && now.getDate() != 13 ? 'rd' : 'th')));
		var nowString =/* dayNames[now.getDay()] + ", " +*/ monthNames[now.getMonth()] + " " + now.getDate()+english_ordinal_suffix /*+ ", " + now.getFullYear()*/;
        var elem = document.getElementById('currentdate');
        if(typeof elem !== 'undefined' && elem !== null) {
            elem.innerHTML = nowString;
        }
    }
if(window.Shopify.routes.root.includes('/es')){
  const escurrentDate = new Date(); // Gets the current date and time
  var elem = document.getElementById('currentdate');
        if(typeof elem !== 'undefined' && elem !== null) {
            elem.innerHTML = escurrentDate.toLocaleDateString('es-ES', { month: 'long',  day: 'numeric' });
        }
}else{
  getFullDate();
}


